const addSeparator = (str, groupLength, separator) => {
  if (!groupLength || str.length <= groupLength) {
    return str
  }

  const portions = []
  for (let index = str.length; index > 0; index -= groupLength) {
    portions.unshift(str.substring(index - groupLength, index))
  }

  return portions.join(separator)
}

export default addSeparator
